// Detect local development so we can use Google's universal reCAPTCHA test key
// (works on any domain, checkbox always passes) instead of the production key,
// which only accepts the real domain.
const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", ""].includes(window.location.hostname);

// Google's official test site key — dev only, provides no real protection.
const RECAPTCHA_TEST_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
// Production reCAPTCHA site key.
const RECAPTCHA_PROD_SITE_KEY = "6LfcXbItAAAAAIAodcbNYT7owmYcOC_lyEqwtxcz";

export const variables = {
  // API_URL: "http://localhost:5000/api/",
  // PHOTO_URL: "http://localhost:5000/Upload/",
  API_URL: "https://api.homedepotoflebanon.com/api/",
  PHOTO_URL: "https://api.homedepotoflebanon.com/Upload/",
  RECAPTCHA_SITE_KEY: isLocalhost ? RECAPTCHA_TEST_SITE_KEY : RECAPTCHA_PROD_SITE_KEY,
  };


  // API_URL:"https://api.homedepotoflebanon.com/api/",
  // PHOTO_URL:"https://api.homedepotoflebanon.com/upload/",

 